import { render } from "./personal.vue?vue&type=template&id=ad093b1c&scoped=true"
import script from "./personal.vue?vue&type=script&lang=js"
export * from "./personal.vue?vue&type=script&lang=js"

import "./personal.vue?vue&type=style&index=0&id=ad093b1c&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad093b1c"]])

export default __exports__